export default "__VITE_ASSET__B9fVagCs__"